<template>
  <div class="container-fluid">
    <div
      class="page-content__header-description"
      style="display: flex; margin-bottom: 20px; margin-left: 10px;"
    >
      <h2 style="flex: 1" class="page-title">Billing</h2>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="switch-row">
        <div class="select-device">
          <el-select
            style="width: 100%"
            v-model="activeDevice"
            id="active-device"
            placeholder="Choose Device"
            @change="changeActiveDevice(activeDevice)"
          >
            <el-option
              v-for="(device, key) in devices"
              :key="key"
              :label="`Device ${device}`"
              :value="device"
            ></el-option>
          </el-select>
        </div>
        <div class="button-text" @click="flutterwavePaygate('10')">
          + Add New Card
        </div>
      </div>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="each-rowsa">
        <div v-for="(card, index) in debitCards" :key="index">
          <div v-if="card.isDefaultCard" class="default-card">
            <div class="single-card">
              <img
                class="arnergy-logo"
                src="../../../assets/img/logo-white.svg"
                alt="arnergy-logo"
              />
              <div class="card-content">
                <h2>{{ "**** **** **** " + card.last4digits }}</h2>
                <p>{{ card.lastName }} {{ card.firstName }}</p>
              </div>
              <div class="card-base">
                <!-- <p>
                  Expires
                  <span>{{
                    months[card.expirymonth] + "/" + card.expiryyear
                  }}</span>
                </p> -->
                <img
                  class="card-logo"
                  v-if="card.cardtype == 'MASTERCARD'"
                  src="../../../assets/img/mastercard-logo.png"
                  alt="card-logo"
                />
                <img
                  class="card-logo"
                  v-else
                  src="../../../assets/img/visa-logo.png"
                  alt="card-logo"
                />
              </div>
            </div>
            <div class="payment-details">
              <div class="left">
                <p>Next Due Payment ({{ formatDate(dueDate) }})</p>
                <h3>
                  NGN
                  {{
                    amountDue
                      ? amountDue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      : "0.00"
                  }}
                </h3>
              </div>
              <button
                @click="makePayment(currentID)"
                :style="
                  notDue
                    ? ''
                    : isDue
                    ? 'border: 1px solid red; color: red; '
                    : ''
                "
              >
                Pay Now
              </button>
            </div>
          </div>
        </div>
        <div v-for="(card, index2) in debitCards" :key="index2" class="list">
          <div v-if="!card.isDefaultCard" class="other-card">
            <div class="single-card">
              <img
                class="arnergy-logo"
                src="../../../assets/img/logo-white.svg"
                alt="arnergy-logo"
              />
              <div class="card-content">
                <h2>{{ "**** **** **** " + card.last4digits }}</h2>
                <p>{{ card.lastName }} {{ card.firstName }}</p>
              </div>
              <div class="card-base">
                <!-- <p>
                  Expires
                  <span>{{
                    months[card.expirymonth] + "/" + card.expiryyear
                  }}</span>
                </p> -->
                <img
                  class="card-logo"
                  v-if="card.cardtype == 'MASTERCARD'"
                  src="../../../assets/img/mastercard-logo.png"
                  alt="card-logo"
                />
                <img
                  class="card-logo"
                  v-else
                  src="../../../assets/img/visa-logo.png"
                  alt="card-logo"
                />
              </div>
            </div>
            <div class="other-details">
              <button @click="setDefaultCard(card.id, card.customerid)">Set as Default Card</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="col-xl-12 col-lg-12 col-md-12 transaction-table">
        <vue-good-table
          class="table"
          :lineNumbers="true"
          :columns="fields"
          :rows="transactionHistory"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          :totalRows="total"
          :pagination-options="{
            enabled: true,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'transactionReference'">
              {{
                props.row.transactionReference
                  ? props.row.transactionReference
                  : "----"
              }}
            </span>

            <span v-if="props.column.field == 'fullName'">
              {{
                props.row.user
                  ? `${props.row.user.firstName} ${props.row.user.lastName}`
                  : "----"
              }}
            </span>

            <span v-if="props.column.field == 'amountPaid'">
              {{
                props.row.actualAmount
                  ? `NGN ${props.row.actualAmount
                      .toFixed(2)
                      .toString()
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
                  : "----"
              }}
            </span>

            <span
              v-if="props.column.field == 'paymentStatus'"
              class="center-svg"
            >
              <span v-if="props.row.status">
                {{
                  props.row.status == "success"
                    ? `Success - **** **** **** ${
                      props.row.detail && props.row.detail.card && props.row.detail.card.last_4digits
                      } (${
                        props.row.detail.card.type
                          .toString()
                          .charAt(0)
                          .toUpperCase() +
                        props.row.detail.card.type
                          .toString()
                          .substr(1)
                          .toLowerCase()
                      })`
                    : "Failed transaction"
                }}
              </span>
              <span v-else> - - - - </span>
            </span>

            <span v-if="props.column.field == 'paymentTime'">
              <span v-if="props.row.createdAt">
                {{ formatDate(props.row.createdAt) }}
                {{ formatTime(props.row.createdAt) }}
              </span>
              <span v-else> - - - - </span>
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import paystack from 'vue-paystack';
import SpinnerLoader from "../../SpinnerLoader.vue";
import { mapGetters } from "vuex";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
} from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_"),
});

const items = [];
export default {
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    SpinnerLoader,
    SpinnerLoader,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  data() {
    return {
      paystackkey: 'pk_test_ef115d721c8b6c98c010166c69eb4b8f57d0dd9a',
      paystackInitialized: false,

      searchTerm: "",
      cardData1: "",
      custData1: "",
      editOffCanvas: false,
      isLoading: false,
      defaultCardSet: false,
      defaultCardID: "",
      custLast4DigitNumber: "",
      amountDue: "",
      totalPrice: "0.00",
      dueDate: "",
      isDue: false,
      notDue: false,
      activeDevice: null,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      regDataParams: {
        name,
      },
      selectOption: {
        enabled: false,
      },
      items: items,
      debitCards: [],
      getUsersDetails: [],
      checkedUser: [],
      currentID: [],
      selectedDevices: [],
      transactionHistory: [],
      processCard: false,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      filter: null,
      modalInfo: {
        title: "",
        content: "",
      },
      fields: [
        {
          field: "transactionReference",
          label: "Transaction Ref",
          sortable: "true",
        },
        {
          field: "fullName",
          label: "Name",
          sortable: "true",
        },
        {
          field: "amountPaid",
          label: "Amount",
          sortable: "true",
        },
        {
          field: "paymentStatus",
          label: "Transaction Status",
          sortable: "true",
        },
        {
          field: "paymentTime",
          label: "Date & Time",
          sortable: "true",
        },
      ],
      transactionHistory: "",
      total: "",
      serverParams: {
        perPage: 10,
        page: 1,
      },
      devices: [],
      tempDevicesList: [],
      newDeviceList: [],
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDummy",
      "getUserSession",
      "getAssignedDevices",
    ]),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("Do MMMM, YYYY");
    },
    formatTime(date) {
      return moment(date).format("hh:mm a");
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.init();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.init();
    },
    init() {
      const httpUtils = this.$httpUtils;
      let url = `/transactionHistories/user`;

      httpUtils.instance
        .get(
          url +
            `?skip=${
              (this.serverParams.page - 1) * this.serverParams.perPage
            }&limit=${this.serverParams.perPage}`
        )
        .then((response) => {
          this.transactionHistory = response.data[0];
          this.total = response.data[1].total;
        })
        .catch((error) => {
          console.log("transactionUrl error", error);
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    },
    changeActiveDevice(id) {
      this.activeDevice = id;
    },
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    fetchDebitCards(id) {
      const HTTP = this.$httpUtils.instance;

      HTTP.get(`/billings/cards`)
        .then((res) => {
          this.debitCards = res.data.data;
          console.log(this.debitCards)
          if (
            this.debitCards.length === 1 &&
            !this.debitCards[0].isDefaultCard
          ) {
            const card = this.debitCards[0];
            this.setDefaultCard(card.id, card.customerid);
            this.fetchDebitCards(this.getUserSession.id);
          }
        })
        .catch((error) => console.log(error));
    },
    setDefaultCard(cardid, custid) {
      const HTTP = this.$httpUtils.instance;
      const data = { cardId: cardid, customerId: custid };

      HTTP.post("/recurringPaymentSetups/setDefaultCard", data)
        .then((res) => {
          this.processCard = true;
          this.defaultCardSet = true;
          this.defaultCardID = cardid;
          this.fetchDebitCards(this.getUserSession.id);
          this.showSuccessMsg({ message: "Default card set successfully!" });
        })
        .catch((error) => {
          this.loader = false;
          console.log({ error: error.response.data.error.message });
          this.showErrorMsg({
            message: error.response.data.error.message,
          });
        });
    },
    deleteModalCard(cardid, custid, custlastDig) {
      this.cardData1 = cardid;
      this.custData1 = custid;
      this.custLast4DigitNumber = custlastDig;
      this.appear();
    },
    appear() {
      this.$modal.show("my-second-modal");
    },
    disappear() {
      this.$modal.hide("my-second-modal");
    },
    cancelModalCard() {
      this.cardData1 = "";
      this.custData1 = "";
      this.custLast4DigitNumber = "";
      this.disappear();
    },
    deleteCard(e) {
      e.preventDefault();

      const HTTP = this.$httpUtils.instance;
      const url = `/recurringPaymentSetups/${this.cardData1}`;
      HTTP.delete(url, this.cardData1)
        .then((res) => {
          this.showSuccessMsg({ message: "Card Deleted!" });
        })
        .catch((error) => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
      this.disappear();
    },
    makePayment(data) {
      const httpUtils = this.$httpUtils;
      let url = `/billings/pay`;

      this.show();

      httpUtils.instance
        .post(url, { paymentIds: data })
        .then((response) => {
          this.hide();
          if (response.data.status == true) {
            //check to be sure the response is an array that has length
            let resData = response.data.data.length
              ? response.data.data.length
              : [response.data.data].length;
            for (let i = 0; i < resData; i++) {
              //multi data type response from endpoint so this check is to make sure the code reads the data appropriately
              if (
                response.data.data.status == "success" ||
                (response.data.data[i] &&
                  response.data.data[i].value.status == "success")
              ) {
                //render success message appropriately
                this.showSuccessMsg({
                  message: response.data.data[i]
                    ? `Installation ID - ${response.data.data[i].value.installationId}\n ${response.data.data[i].value.message}`
                    : response.data.data.message,
                });
                this.checkedUser = [];
                this.totalPrice = "0.00";
                setTimeout(this.init(), 3000);
              } else {
                this.showErrorMsg({
                  message: `Installation ID - ${response.data.data[i].value.installationId}\n ${response.data.data[i].value.message}`,
                });
                setTimeout(this.init(), 3000);
              }
            }
          } else {
            this.showErrorMsg({
              message:
                response.data.data && response.data.data.message
                  ? response.data.data.message
                  : response.data.message,
            });
            setTimeout(this.init(), 3000);
          }
        })
        .catch((error) => {
          this.hide();
          console.log("payment error", error);
          this.showErrorMsg({ message: "Payment error. Kindly try again!" });
        });
    },
    setCurrentAfterPayment() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const txref = params["tx_ref"];

      console.log("txref", txref);

      if (!txref) {
        return;
      }
      const data = {
        txref: txref,
      };

      const HTTP = this.$httpUtils.instance;
      HTTP.post("/billings/add-card", data)
        .then((res) => {
          console.log("testing", res.data);
          if (res.data) {
            this.showSuccessMsg({ message: "Card successfully added!" });
            this.fetchDebitCards(this.getUserSession.id);
          } else {
            console.log("Nothing to show here");
          }
          window.history.back();
        })
        .catch((error) => {
          this.showErrorMsg({
            message: error.response.data.error.message.message,
          });
          console.log("testing error", error.response);
        });
    },
    flutterwavePaygate(amount) {
      if (amount === "10") this.processCard = true;
      const finalAmount = this.processCard ? amount : this.amountDue;

      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: finalAmount,
        // amount: amount === "10" ? amount : this.firstPaymentAmt ? "10" : "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "/billing",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a",
        },
        customer: {
          email: this.getUserSession.email,
          phone_number: this.getUserSession.phoneNumber,
          name:
            this.getUserSession.firstName + " " + this.getUserSession.lastName,
        },
        callback: function (data) {
          console.log("flutterwaveCheckout", data);
        },
        onclose: function (data) {
          // close modal
          console.log("on close", data);
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg",
        },
      });
    },
    
    payMultiple() {
      let sum = 0;
      let selectedDevices = [];

      for (let i = 0; i < this.checkedUser.length; i++) {
        selectedDevices.push(parseInt(this.checkedUser[i].id));
        sum += parseInt(this.checkedUser[i].monthlyCharge);
      }

      this.selectedDevices = [...new Set(selectedDevices)];
      this.totalPrice = sum.toFixed(2).toString();
    },
    formatDate(date) {
      let date1 = new Date();
      let date2 = new Date(moment(date).format("YYYY/MM/DD"));
      let daysleft = Math.ceil(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );

      if (daysleft > 15) {
        this.notDue = true;
      } else if (daysleft < 1) {
        this.isDue = true;
      }
      if (date) {
        return moment(date).format("Do MMMM, YYYY");
      } else {
        return `- - - -`;
      }
    },
    historyDate(date) {
      if (date) {
        return moment(date).format("Do MMMM, YYYY");
      } else {
        return `- - - -`;
      }
    },
    init() {
      const httpUtils = this.$httpUtils;
      let dashboardUrl = `/billings/dashboard`;
      let transactionUrl = `/transactionHistories/user`;

      httpUtils.instance
        .get(dashboardUrl)
        .then((response) => {
          console.log(response.data);
          this.amountDue = response.data.data.summary.monthlyCharge;
          this.currentID[0] = parseInt(response.data.data.summary.id);
          this.dueDate = response.data.data.summary.monthlyrecurringchargedate;
          this.getUsersDetails = response.data.data.schedule;
        })
        .catch((error) => {
          console.log("tracker error", error);
        });

      httpUtils.instance
        .get(transactionUrl)
        .then((response) => {
          this.transactionHistory = response.data[0].slice(0, 5);
          console.log("t response", this.transactionHistory);
        })
        .catch((error) => {
          console.log("transactionUrl error", error);
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    },
  },
  async mounted() {
    this.init();
    this.fetchDebitCards(this.getUserSession.id);
    this.setCurrentAfterPayment();
    if (this.$can("am", "sm")) {
      this.devices = JSON.parse(this.getUserSession.assignedDevices);
      // JSON.parse(this.getUserSession.assignedDevices).map((dev, ind) => {
      //   this.getUsersDetails.map(single => {
      //     console.log('user session', single)
      //     if (single.cid === dev) this.devices.splice(ind, 1)
      //   })
      // })
    } else {
      this.devices = this.getAssignedDevices;
      // this.getAssignedDevices.map((dev, ind) => {
      //   this.getUsersDetails.map('assigned session', single => {
      //     if (single.cid === dev) this.devices.splice(ind, 1)
      //   })
      // })
    }
    this.changeActiveDevice(this.devices[0]);
    console.log(this.devices);
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
h5,
p,
li {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  color: #777676;
}

h1 {
  color: #000000;
  font-size: 30px;
  font-weight: 700;
}

h2 {
  font-size: 24px;
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

h3 {
  font-size: 14px;
}

h4 {
  font-size: 18px;
}

h5 {
  color: #444444;
  font-size: 14px;
  margin-top: auto;
  font-weight: 500;
}

p {
  color: #000000;
  font-size: 16px;
  font-weight: 700;
}

.each-row,
.each-rowsa {
  display: flex;
  flex-direction: row;
  justify-content: start;
  margin-top: 20px;
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;

  .default-card {
    margin-right: 26px;
  }
  
  &::-webkit-scrollbar{
    display: none;
  }
}
.switch-row {
  display: flex;
  justify-content: start;
  align-items: center;
}
.default-card,
.other-card {
  width: 340px;
}
.single-card {
  width: 340px;
  height: 195px;
  border-radius: 10px;
  background: url("../../../assets/img/card-bg.svg");
  position: relative;
  padding: 16px;

  img.arnergy-logo {
    width: 102px;
  }

  .card-content {
    position: absolute;
    top: 40%;

    h2 {
      font-size: 30px;
      font-weight: bold;
      color: #ffffff;
    }

    p {
      color: #ffffff;
      font-weight: 100;
    }
  }

  .card-base {
    position: absolute;
    bottom: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: calc(100% - 32px);

    p {
      font-size: 10px;
      color: rgba(255, 255, 255, 0.75);
      font-weight: 100;

      span {
        font-weight: 600;
      }
    }
  }

  img.card-logo {
    width: 48px;
  }
}
.payment-details {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  height: 33px;

  .left p {
    font-size: 10px;
    color: #0892d0;
    font-weight: 300;
    margin: 0;
  }

  .left h3 {
    font-size: 16px;
    font-weight: bold;
    color: #757575;
    margin: 0;
  }

  button {
    border: 1px solid #0892d0;
    outline: none;
    background: none;
    border-radius: 5px;
    color: #0892d0;
    width: 88px;
    font-size: 12px;
  }
}
.other-details {
  margin-top: 12px;

  button {
    border: 0.5px solid #757575;
    outline: none;
    background: none;
    border-radius: 5px;
    color: #757575;
    width: 100%;
    height: 33px;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      border-color: #0892d0;
      color: #0892d0;
    }
  }
}
.transaction-table {
  margin-top: 20px;
  height: calc(100vh - 600px);
}
.card {
  width: 410px;
  height: 195px;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  padding: 20px 12px;
  background: #ffffff;
  border-radius: 6.5px;
  text-align: left;

  h3 {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #0892d0;
  }

  &.normal {
    background: #ffbf00;

    h1,
    h2,
    h3 {
      color: white;
    }
  }

  &.due {
    background: red;

    h1,
    h2,
    h3 {
      color: white;
    }
  }

  &.notdue {
    background: green;

    h1,
    h2,
    h3 {
      color: white;
    }
  }
}

.header {
  color: #000000;
  margin-bottom: 17px;
  font-weight: 700;
}

.form {
  margin: 100px auto;
}
.form h4 {
  font-size: medium;
  font-weight: 150px;
  text-align: center;
}
.form p {
  font-size: larger;
  font-weight: 250px;
  text-align: center;
}

.top-header {
  display: flex;
  justify-content: space-between;
}

.list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: 26px;

  &:last-child {
    margin-right: 0px;
  }
}

.card-height {
  height: 100%;
  overflow-y: scroll;
}

.history-details {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
  color: #777676;

  &.small {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }

  &.large {
    font-size: 14px;
    line-height: 18px;
  }
}

.card-box {
  display: flex;
  flex-direction: column;
}

.card-section {
  display: flex;
  flex-direction: row;
  width: 800px;
}

.single-card {
  margin-right: 37px;
}

.pay-button {
  border-radius: 5px;
  padding: 11px 30px;
  text-align: center;
  max-width: 88px;
  margin-top: auto;
  background: #ffffff;
  display: flex;
  border: 1px solid #0892d0;
  color: #0892d0;
  cursor: pointer;
}

.recurring {
  display: flex;
  flex-direction: column;
  margin-right: 27px;
  width: 810px;
  padding: 28px 48px;
  background: #ffffff;
  border-radius: 10px;
}

.recurring-info {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;

  &.total {
    background: #0892d0;
    border-radius: 6.5px;
    padding: 15px 24px;

    p {
      color: #ffffff;
    }
  }

  &.device {
    margin: 13px 0px;
    padding: 9px;
    border-bottom: 1px dashed #e8e2e2;
  }
}

.name-info {
  display: flex;
}

.card-title {
  font-size: 2.6rem;
}

.checkbox {
  margin-right: 20px;
  width: 20px;
  height: 20px;
  accent-color: green;
}

.history {
  margin: 17px 0px;
}

.text-vertical-spacing {
  margin: 5px 0px;
}

.mini-text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #b9b9b9;
  cursor: pointer;
}

.button-text {
  font-size: 14px;
  font-weight: 600;
  color: #3b83b3;
  margin-left: 40px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}

.text-button {
  font-weight: 700;
  color: #0892d0;
  background: #ffffff;
  border: none;
  width: 130px;
}
.delete-button {
  color: red;
  font-weight: 650;
  font-size: 12px;
  border: none;
  background: transparent;
  margin-left: 26px;
}

.process {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15%;
}

.select-device {
  width: 235px;
  /* height: 50px; */
}

@media (max-width: 768px) {
  .each-rowsa {
    flex-direction: column;
    justify-content: flex-start;
  }
}

@media (max-width: 1300px) {
  .each-row {
    flex-direction: column;
    justify-content: flex-start;
  }

  .card {
    width: 90vw;
    max-width: 410px;
    margin-left: 5px;
    margin-top: 15px;
  }
  .card-section {
    flex-direction: column;
  }

  .card-box {
    margin: 16px 10px;
    max-width: 500px;
  }

  .recurring {
    margin: 16px 10px;
    max-width: 90vw;
    padding: 32px;
  }

  .logo {
  width: 100px; 
  height: 50px; 
  margin-right: 5px; 
}
 .logo2{
  width: 100px; 
  height: 50px; 
  margin-right: 5px; 
}
}
</style>



// WEBPACK FOOTER //
// src/components/pages/billing/Billing.vue